/**
 * Preferencia de ordenacao da listagem de produtos.
 *
 * A chave NAO pode conter "muven-": o interceptor de autenticacao
 * (src/auth/interceptors/registerAuthInterceptor.ts) injeta como header HTTP toda chave
 * de localStorage que casa com /muven-/.
 *
 * Nada limpa essa chave - o logout so remove `muven-client-id` e a expiracao de token so
 * reescreve `authorization` -, entao a preferencia sobrevive a expiracao de sessao.
 */
const PRODUCT_LIST_SORT = 'product-list-sort'

export const SORT_FIELDS = ['id']
export const SORT_ORDERS = ['asc', 'desc']

export interface ProductListSort {
    field: string;
    order: 'asc' | 'desc';
}

function defaultSort():ProductListSort {
    return { field: 'id', order: 'desc' }
}

function isValid(sort:any):boolean {
    return !!sort
        && SORT_FIELDS.indexOf(sort.field) !== -1
        && SORT_ORDERS.indexOf(sort.order) !== -1
}

export default {
    getSort():ProductListSort {
        try {
            const stored = JSON.parse(localStorage.getItem(PRODUCT_LIST_SORT) || 'null')

            if (!isValid(stored)) {
                return defaultSort()
            }

            return { field: stored.field, order: stored.order }
        } catch (e) {
            // valor corrompido ou de uma versao anterior nunca pode quebrar a tela
            return defaultSort()
        }
    },
    setSort(sort:ProductListSort):void {
        if (!isValid(sort)) {
            return
        }

        localStorage.setItem(PRODUCT_LIST_SORT, JSON.stringify({ field: sort.field, order: sort.order }))
    },
}
